//屏幕适配用
const win_adaptive = function () {
    let delMeta = function (metaName) {
        const metas = document.getElementsByTagName('meta');
        for (let i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute('name') === metaName) {
            return metas[i].parentNode.removeChild(metas[i])
            }
        }
    }
    let initScale = (1 / window.devicePixelRatio).toFixed(2); 
    
    let initHeight = window.outerHeight;
    let initWidth = window.document.documentElement.clientWidth; 
    let num = 1;
    if(initHeight <= 980){
        num = Number((initHeight/980).toFixed(2))
    }
    if(initWidth <= 1820){
        num = Number((initWidth/1820).toFixed(2))
    }
    if(num < 0.7){
        num = 0.7
    }
    if(num > 1){
        num = 1
    }
//    document.getElementsByTagName('html')[0].setAttribute('style','zoom:'+num+';');
    if(navigator.userAgent.indexOf("Firefox")>0){
        let width = Math.round(1/num*100)
        document.getElementsByTagName('html')[0].setAttribute('style','overflow-x: hidden;');
        document.getElementById('app').setAttribute('style','zoom:'+num+';-moz-transform:scale('+ num +');-moz-transform-origin:0 0;width:'+width+'%;margin-bottom:-99999px;min-width:1820px;');
    }else{
        document.getElementsByTagName('html')[0].setAttribute('style','zoom:'+num+';');
        document.getElementById('app').setAttribute('style','min-width:1820px;');
    }
    // document.getElementById('app').setAttribute('style','-moz-transform:scale('+ num +');-moz-transform-origin:top left;');
    // document.getElementsByTagName('html')[0].setAttribute('style','-moz-transform:scale('+ num +' '+ num +')');
    // document.getElementsByTagName('html')[0].setAttribute('style','-moz-transform-origin:center center');
    delMeta('viewport');
    let meta = '<meta name="viewport" content="width=device-width,user-scalable=no,initial-scale='+ initScale +',minimum-scale='+ initScale +',maximum-scale='+ initScale +'">';
    document.getElementsByTagName('head')[0].innerHTML += meta;
    // let initWidth = window.document.documentElement.clientWidth; 
    document.getElementsByTagName('body')[0].style.fontSize = initWidth / 90 + 'px !important';
    document.getElementsByTagName('body')[0].setAttribute('style','opacity:1;font-size:'+((initWidth / 90)>14?14:initWidth / 90)+'px');
}

export default win_adaptive;


// WEBPACK FOOTER //
// ./src/util/adaptive.js